<script lang="ts">
import { onMount } from 'svelte';
import { auth } from './store/auth';
import LoginForm from './components/LoginForm.svelte';
import MainView from './views/Main.svelte';

onMount(() => auth.check());
</script>

{#if $auth.checking}
    <div class="check">Проверка</div>
{:else if $auth.session}
    <MainView />
{:else}
    <LoginForm />
{/if}
